import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/LoginView.vue'
import Dashboard from '../views/DashboardView.vue'
import CallDetailsView from '../views/CallDetailsView.vue'
import AppLayout from '@/layouts/AppLayout.vue'
import ConversationsView from '@/views/ConversationView.vue';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'LoginView',
    component: Login
  },
  {
    path: '/',
    component: AppLayout, // The layout with sidebar
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'DashboardView',
        component: Dashboard
      },
      {
        path: 'call-details',
        name: 'CallDetailsView',
        component: CallDetailsView
      },
      {
        path: 'conversations',
        name: 'ConversationsView',
        component: ConversationsView  
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router